<template>
  <div
    class="col-12 card p-3"
    style="background-color:#f0f2f7;"
  >
    <div
      class="form-check custom-control custom-radio"
      id="delivery-address-radio"
      v-if="!editEnabled"
    >
      <input
        :id="'delivery-address-'+userAddress.addressId"
        type="radio"
        class="form-check-input  custom-control-input"
        :value="userAddress"
        v-model="data.selectedAddress"
        @change="update()"
        v-if="showInputRadio"
								data-test="AddressListTemplateRadioInput"
      >
      <label
        class="form-check-label custom-control-label align-middle"
        :id="'delivery-address-label-'+userAddress.addressId"
        :for="'delivery-address-'+userAddress.addressId"
								data-test="AddressListTemplateDetails"
      >
        {{userAddress.firstName}} {{userAddress.lastName}},
        {{userAddress.addressLine1}},
        {{userAddress.locality}},
        {{userAddress.state}},
        {{userAddress.country}},
        {{userAddress.pinCode}}
      </label>
      <button
        class="float-right btn btn-link text-black-50"
        @click.prevent="deleteAddress(userAddress.addressId)"
        v-if="$route.path !== '/checkout' && showDelete"
        :id="'delivery-delete-address-'+userAddress.addressId"
								data-test="AddressListTemplateDlteBtn"
      >
        <i class="fas fa-trash" data-test="AddressListTemplateDlteIcon" :id="'AddressListTemplateDeleteIcon'+userAddress.addressId"></i>
      </button>
      <button
        class="btn btn-link text-black-50"
        @click.prevent="editAddress()"
        v-if="$route.path !== '/checkout' && showEdit"
        :id="'delivery-edit-address-btn-'+userAddress.addressId"
								data-test="AddressListTemplateEditBtn"
      >
        Edit
      </button>
    </div>
    <div v-if="editEnabled">
      <address-form
        @cancel="cancelForm()"
        :address="userAddress"
        @submitSuccess="updateAddress($event)"
      >
      </address-form>
    </div>
  </div>
</template>

<script>
import AddressForm from '@/components/shared/forms/AddressForm'
import { customerApi } from '@/services/ApiServices/customerApi'

export default {
	props: {
		data: {
			type: Object
		},
		address: {
			type: Object,
			default: () => ({})
		},
		showInputRadio: {
			type: Boolean,
			default: true
		},
		showEdit: {
			type: Boolean,
			default: true
		},
		showDelete: {
			type: Boolean,
			default: true
		}
	},
	mounted () {
		this.userAddress = this.address
	},
	data () {
		return {
			editEnabled: false,
			userAddress: Object
		}
	},
	components: {
		AddressForm
	},
	methods: {
		cancelForm () {
			this.editEnabled = false
			this.$emit('cancel', false)
		},
		editAddress () {
			this.editEnabled = true
			this.$emit('editAddress', true)
		},
		deleteAddress (addressId) {
			this.editEnabled = false
			this.$emit('delete', addressId)
		},
		updateAddress (addressData) {
			let addressChanged = false
			for (const key in this.userAddress) {
				//
				if (this.userAddress[key] !== addressData[key]) {
					addressChanged = true
					break
				}
			}
			if (addressChanged === true) {
				this.userAddress = addressData
				delete addressData.countryData
				customerApi.editAddress(addressData, this.userAddress.addressId).then((res) => {
					this.editEnabled = false
					// this.$emit('updateSuccess', addressData);
				}).catch(() => {
					this.editEnabled = false
					this.$emit('updateSuccess', this.user)
				})
			} else {
				this.editEnabled = false
				this.$toasted.show('No change found')
				// this.$emit('updateSuccess', this.user);
			}
		},
		update () {
			this.$forceUpdate()
			this.$emit('addressChoosed')
		}
	}
}
</script>
